import { useState } from 'react';
import type { AssetImportStatus } from '../assetImportMatchy.types';

export function useAssetImportFeedback() {
  const [error, setError] = useState<string | null>(null);
  const [confirmationMessage, setConfirmationMessage] = useState<string | null>(
    null,
  );
  const [status, setStatus] = useState<AssetImportStatus>('idle');

  return {
    confirmationMessage,
    error,
    setConfirmationMessage,
    setError,
    setStatus,
    status,
  };
}
